import { InfoIcon } from "lucide-react";
import React from "react";

import { cn } from "@/utils/shadcn-ui";

import { Tooltip } from "./tooltip";

export function HelperTooltip({
  className,
  content,
}: {
  className?: string;
  content: React.ReactNode;
}) {
  return (
    <Tooltip content={content} side="top">
      <span
        className={cn("inline-flex cursor-help p-0.5 align-middle", className)}
      >
        <InfoIcon className="text-muted-foreground size-3.5 shrink-0" />
      </span>
    </Tooltip>
  );
}
